export default "__VITE_ASSET__BmyA02O6__"